export const FormItemsWrap = ({
  children,
  direction,
  gap,
  justifyContent,
  alignItems,
  width,
  alignContent,
  marginTop,
  marginLeft,
  onClick,
  showPointer,
  onPaste,
  bgColor,
  height,
  borderRadius,
  padding,
  addBorder,
  mB
}) => {
  return (
    <div
      style={{
        width: width,
        display: "flex",
        flexDirection: direction || "column",
        gap: gap || "4px",
        justifyContent: justifyContent || undefined,
        alignItems: alignItems || undefined,
        alignContent: alignContent || undefined,
        marginTop,
        marginLeft,
        marginBottom: mB,
        backgroundColor: bgColor,
        cursor: showPointer && "pointer",
        height,
        borderRadius: borderRadius,
        padding: padding,
        border: addBorder && `1px solid #CCE4FF`,
      }}
      onClick={onClick}
      onPaste={onPaste}
    >
      {children}
    </div>
  );
};
